var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.selectedLocation
    ? _c(
        "ul",
        { staticClass: "location-search-container__results--list" },
        [
          _vm.filteredLocations.length > 0
            ? _vm._l(_vm.filteredLocations, function(location) {
                return _c(
                  "li",
                  {
                    key: location.id,
                    staticClass: "location-search-container__results--list-item"
                  },
                  [
                    _c("results-list-item", {
                      attrs: {
                        location: location,
                        selectLocationClick: _vm.selectLocationClickFn
                      }
                    })
                  ],
                  1
                )
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.filteredLocations.length && !_vm.isInitializing && !_vm.isLoading
            ? _c("li", { staticClass: "no-results px-2" }, [
                _c("h5", [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.text("noResults")) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "noresultstarget" })
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.filteredLocations.length && (_vm.isInitializing || _vm.isLoading)
            ? _c("li", { staticClass: "loading-results px-2" }, [
                _c("h5", [_vm._v("Loading...")])
              ])
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }